import React from "react"
import { Cell } from "fixed-data-table-2"

export default class TextCell extends React.PureComponent {
  render () {
    const { data, rowIndex, columnKey } = this.props
    return <Cell>{data[rowIndex][columnKey]}</Cell>
  }
}
